/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestTokenHelper,
  TestTokenHelperInterface,
} from "../TestTokenHelper";

const _abi = [
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610430806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063a86e357614610030575b600080fd5b61004361003e366004610243565b610059565b60405161005091906102a3565b60405180910390f35b60606100648261006a565b92915050565b6040805160048152602481019091526020810180516001600160e01b03166395d89b4160e01b17905260609060009081906100a6908590610110565b915091508115806100b657508051155b156100db5750506040805180820190915260018152603f60f81b602082015292915050565b60208151036100f5576100ed816101c4565b949350505050565b808060200190518101906100ed91906102ec565b5050919050565b60006060833b610133576040516373d39f9d60e01b815260040160405180910390fd5b600080856001600160a01b03168560405161014e9190610399565b600060405180830381855afa9150503d8060008114610189576040519150601f19603f3d011682016040523d82523d6000602084013e61018e565b606091505b5091509150816101b5576000604051806020016040528060008152509350935050506101bd565b600193509150505b9250929050565b805160609060005b81811015610109578381815181106101e6576101e66103b5565b01602001516001600160f81b0319161561023b578284828151811061020d5761020d6103b5565b602001015160f81c60f81b6040516020016102299291906103cb565b60405160208183030381529060405292505b6001016101cc565b60006020828403121561025557600080fd5b81356001600160a01b038116811461026c57600080fd5b9392505050565b60005b8381101561028e578181015183820152602001610276565b8381111561029d576000848401525b50505050565b60208152600082518060208401526102c2816040850160208701610273565b601f01601f19169190910160400192915050565b634e487b7160e01b600052604160045260246000fd5b6000602082840312156102fe57600080fd5b815167ffffffffffffffff8082111561031657600080fd5b818401915084601f83011261032a57600080fd5b81518181111561033c5761033c6102d6565b604051601f8201601f19908116603f01168101908382118183101715610364576103646102d6565b8160405282815287602084870101111561037d57600080fd5b61038e836020830160208801610273565b979650505050505050565b600082516103ab818460208701610273565b9190910192915050565b634e487b7160e01b600052603260045260246000fd5b600083516103dd818460208801610273565b6001600160f81b031993909316919092019081526001019291505056fea2646970667358221220018fa1c31b12cd41c4644446b7d8e706337794c939923b7c8ec70d3e1766aabb64736f6c634300080d0033";

type TestTokenHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestTokenHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestTokenHelper__factory extends ContractFactory {
  constructor(...args: TestTokenHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TestTokenHelper";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestTokenHelper> {
    return super.deploy(overrides || {}) as Promise<TestTokenHelper>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestTokenHelper {
    return super.attach(address) as TestTokenHelper;
  }
  connect(signer: Signer): TestTokenHelper__factory {
    return super.connect(signer) as TestTokenHelper__factory;
  }
  static readonly contractName: "TestTokenHelper";
  public readonly contractName: "TestTokenHelper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestTokenHelperInterface {
    return new utils.Interface(_abi) as TestTokenHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestTokenHelper {
    return new Contract(address, _abi, signerOrProvider) as TestTokenHelper;
  }
}
